import apiClient from '@/services/axios'

export async function put(booking, acceptSoftWarnings) {
  let acceptSoftWarningsString = '';
  if(acceptSoftWarnings) {
    acceptSoftWarningsString = '?accept-soft-warnings=true';
  }
  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/' + booking.id + acceptSoftWarningsString, booking);

  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to put booking.')
}
